export default {
  finalize() {
    $('#modaleLemma').on('show.bs.modal', function (event) {
      var modal = $(this);
      var lemma = $(event.relatedTarget);
      /* eslint-disable no-console */
      var url = lemma.attr("href");
      /* eslint-disable no-console */
      console.log(url);
      var request = new XMLHttpRequest();
      request.open('GET', url, true);

      request.onload = function() {
        if (request.status >= 200 && request.status < 400) {
          var resp = request.responseText;
          modal.find('.modal-body').html(resp);
        } else {
          // We reached our target server, but it returned an error

        }
      };

      request.onerror = function() {
        // There was a connection error of some sort
      };

      request.send();
    });
    $('#modaleLemma').on('hidden.bs.modal', function () {
      var modal = $(this);
      modal.find('.modal-body').html("");
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/gdbtf.js